import { useNavigate } from 'react-router-dom'

import { AffiliateFormComponent } from '../../components/AffiliateForm'
import { LayoutPage } from '../../components/LayoutPage'
import { PageTitleComponent } from '../../components/PageTitleComponent'

import { useControlSearchAffiliates } from '../../hooks/useControlSearchAffiliates'
import { useSimpleState } from '../../hooks/useSimpleState'

const CreateAffiliatePage = () => {
    const navigate = useNavigate()

    const { _state } = useSimpleState({
        fetching: false
    })

    const {_state: _errors} = useSimpleState({})

    const {_control} = useControlSearchAffiliates()

    const handleSubmit = (body) => {
        _state.set('fetching', true)

        _control.fetchCreate(body).then(res => {
            if (res.status === 200) {
                navigate('/affiliates')
            } else {
                _errors.set(res.errors?.errors || {})
            }
        }).finally(() => {
            _state.set('fetching', false)
        })
    }

    return (
        <div>
            <LayoutPage config={{ id: 'ManageDeals' }}>
                <PageTitleComponent value="Create Affiliate" />

                <div className={_state.get('fetching') ? 'disabled' : ''}>
                    <AffiliateFormComponent config={{
                        errors: _errors.get()
                    }} events={{
                        handleSubmit: handleSubmit
                    }} />
                </div>
            </LayoutPage>
        </div>
    )
}

export { CreateAffiliatePage }
